import React from 'react';
import styles from './UpsellCardUIComponents.module.css';

type DataAttributes = {
  [key: `data-${string}`]: string | number | boolean | undefined;
};

type DivProps = React.HTMLAttributes<HTMLDivElement> & DataAttributes;
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & DataAttributes;
type SpanProps = React.HTMLAttributes<HTMLSpanElement> & DataAttributes;
type HeadingProps = React.HTMLAttributes<HTMLHeadingElement> & DataAttributes;
type ParagraphProps = React.HTMLAttributes<HTMLParagraphElement> & DataAttributes;

const cx = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ');

export const Container = React.forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cx(styles.container, className)} {...props} />
  ),
);
Container.displayName = 'Container';

export const ImageContainer = React.forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cx(styles.imageContainer, className)} {...props} />
  ),
);
ImageContainer.displayName = 'ImageContainer';

export const Content = React.forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cx(styles.content, className)} {...props} />
  ),
);
Content.displayName = 'Content';

export const CardTopSection = React.forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cx(styles.cardTopSection, className)} {...props} />
  ),
);
CardTopSection.displayName = 'CardTopSection';

export const CardBottomSection = React.forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cx(styles.cardBottomSection, className)}
      {...props}
    />
  ),
);
CardBottomSection.displayName = 'CardBottomSection';

export const Title = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...props }, ref) => (
    <h3 ref={ref} className={cx(styles.title, className)} {...props} />
  ),
);
Title.displayName = 'Title';

export const Description = React.forwardRef<
  HTMLParagraphElement,
  ParagraphProps
>(({ className, ...props }, ref) => (
  <p ref={ref} className={cx(styles.description, className)} {...props} />
));
Description.displayName = 'Description';

export const PriceContainer = React.forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cx(styles.priceContainer, className)} {...props} />
  ),
);
PriceContainer.displayName = 'PriceContainer';

export const BaseAddToCartButton = React.forwardRef<
  HTMLButtonElement,
  ButtonProps
>(({ className, ...props }, ref) => (
  <button
    ref={ref}
    className={cx('gtm', styles.baseAddToCartButton, className)}
    {...props}
  />
));
BaseAddToCartButton.displayName = 'BaseAddToCartButton';

export const AddedToCartDisclaimer = React.forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cx(styles.addedToCartDisclaimer, className)}
      {...props}
    />
  ),
);
AddedToCartDisclaimer.displayName = 'AddedToCartDisclaimer';

export const CtaContainer = React.forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cx(styles.ctaContainer, className)} {...props} />
  ),
);
CtaContainer.displayName = 'CtaContainer';

export const AddToCartButtonContent = React.forwardRef<
  HTMLSpanElement,
  SpanProps
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cx(styles.addToCartButtonContent, className)}
    {...props}
  />
));
AddToCartButtonContent.displayName = 'AddToCartButtonContent';

export const Tag = React.forwardRef<HTMLSpanElement, SpanProps>(
  ({ className, ...props }, ref) => (
    <span ref={ref} className={cx(styles.tag, className)} {...props} />
  ),
);
Tag.displayName = 'Tag';

export const LearnMoreLink = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => (
    <button
      ref={ref}
      className={cx('gtm', styles.learnMoreLink, className)}
      {...props}
    />
  ),
);
LearnMoreLink.displayName = 'LearnMoreLink';

export const Backdrop = React.forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cx(styles.backdrop, className)} {...props} />
  ),
);
Backdrop.displayName = 'Backdrop';
